import { render } from "./BasicLeft.vue?vue&type=template&id=2343048e&scoped=true"
import script from "./BasicLeft.vue?vue&type=script&lang=js"
export * from "./BasicLeft.vue?vue&type=script&lang=js"

import "./BasicLeft.vue?vue&type=style&index=0&id=2343048e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2343048e"]])

export default __exports__